// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"662":"82e192e29bf4da5a","888":"cb7c77d0641eaa6e"}[chunkId] + ".css";
};